<template>
    <div id="loader">
        <div class="load-center">
            <div class="loading"></div>
            <h2 class="text-load" data-text=""></h2>
        </div>
    </div>
</template>

<style scoped>
#loader{
    display: none;
}
#loader.load-info, #loader.load-page{
    display: flex;
}
.load-info,
.load-page {
    position: fixed;
    z-index: 9999999999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.75s, visibility 0.75s;
    opacity: 0;
    visibility: hidden;
    user-select: none;
}

.load-info {
    background-color: rgba(0, 0, 0, 0.825);
}

.load-page {
    background: radial-gradient(circle, #1B2540 0%, #060911 100%);
    color: var(--white);
}

.load-info .text-load{
    color: var(--white);
}
.text-load{
    color: var(--texr-label);
    margin-top: 1rem;
} 
.text-load::after {
    content: attr(data-text);
    font-weight: bold;
    animation: loading-text 5.25s infinite;
    font-size: 1.5rem;
}
@keyframes loading-text {
    0% {
        content: attr(data-text) '';
    }
    10% {
        content: attr(data-text) '.';
    }
    30% {
        content: attr(data-text) '..';
    }
    60% {
        content: attr(data-text) '...';
    }
    100% {
        content: 'Espere un poco mas de favor...';
    }
}
.load-info.show,
.load-page.show {
    opacity: 1;
    visibility: initial;
}
.load-center{
    display: grid;
    place-items: center;
}
.loading {
    position: relative;
    width: 74px;
    aspect-ratio: 1;
    border-radius: 50%;
}
.loading::before,
.loading::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50%;
}
.loading::before {
    background: conic-gradient(from 0deg, transparent 0%, var(--primary-soft) 20%, var(--primary) 55%, var(--second-soft) 85%, transparent 100%);
    -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 7px), #000 calc(100% - 7px));
    mask: radial-gradient(farthest-side, transparent calc(100% - 7px), #000 calc(100% - 7px));
    animation: spin-ring 1s linear infinite;
}
.loading::after {
    inset: 16px;
    background: var(--primary);
    opacity: .18;
    animation: pulse-core 1.6s ease-in-out infinite;
}
@keyframes spin-ring {
    to { transform: rotate(1turn); }
}
@keyframes pulse-core {
    0%, 100% { transform: scale(.7); opacity: .12; }
    50% { transform: scale(1); opacity: .3; }
}


.load-info .spinner,
.load-page .spinner {
    width: 6rem;
    padding: 8px;
    aspect-ratio: 1;
    border-radius: 50%;
    --_m:
        conic-gradient(#0000 10%, #000),
        linear-gradient(#000 0 0) content-box;
    -webkit-mask: var(--_m);
    mask: var(--_m);
    -webkit-mask-composite: source-out;
    mask-composite: subtract;
    animation: s3 .85s infinite linear;
    margin: 0 auto;
}
.load-info .spinner{
    background: var(--primary);
}
.load-page .spinner{
    background: var(--primary);
}
@keyframes s3 {
    to {
        transform: rotate(1turn)
    }
}
</style>